import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
    return (
        <div className='flex flex-col justify-center items-center h-[70vh] md:flex-row pt-5'>

            <Link to="/aboutme" className='w-64 h-64 rounded-full overflow-hidden border-8 cursor-pointer md:ml-20 bg-principal text-white border-principal hover:bg-white hover:text-principal hover:scale-95 transition-all duration-200 ease-out'>
                <img src={`${process.env.PUBLIC_URL}/mamá2.png`} alt='Avatar' className='w-full h-full object-cover object-bottom' />
            </Link>

            <div className='flex-col pl-0 pt-5 md:pt-0 md:pl-5 text-center md:text-left'>

                <div className=' font-mukta font-bold text-2xl text-principal'>
                    <h2>
                        Hola! soy Alba Luz Ramos
                    </h2>
                </div>

                <div className=' font-mukta font-bold pb-10 text-5xl text-principal'>
                    <h1>
                        ¿En qué puedo ayudarte?
                    </h1>
                </div>

                <div className='flex-col pt-5 md:pt-0 text-center md:text-left'>
                    <Link to="/menu" className='text-center text-2xl bg-principal text-white py-2 px-5 rounded-full border-2 border-principal font-semibold hover:bg-white hover:text-principal hover:scale-95 transition-all duration-200 ease-out'>
                        Mira mis servicios
                    </Link>
                </div>
                
            </div>

        </div>
    )
}

export default Home